import { EntityConstants } from '../../helpers/general.helper';
import { Historia } from './historia.types';

export const turnosConstants: EntityConstants = {
	apiEndpoint: '/api/turnos',
	entityLabel: 'Turno',
	navigateToParent: '',
	entityLabelGender: 'M'
}

export enum TurnoStatus {
    IMPAGO = 'NOPA',
    PENDIENTE = 'PEND',
    CANCELADO = 'CANC',
    COMPLETADO = 'DONE',
}

export enum TurnosFilter {
	PENDIENTES = 'pendientes',
	ANTERIORES = 'anteriores'
}

export interface Turno {
	id: number,
	fecha: string,
	hora: string,
	medicoDni: number,
	medicoNombre: string,
	pacienteDni: number,
	pacienteNombre: string,
	pacienteEmail?: string,
	prepaga?: string,
	afiliadoNro?: string,
	especialidadId: number,
	especialidadNombre: string,
	duracion: number,
	motivoConsulta: string,
	statusTurno: TurnoStatus,
	canceladoPor?: string,
	pagoId?: string,
	tarifa: number,
	comision: number,
	historia?: Historia[],
	linkLlamada?: string,
}